import React, { useState, useEffect } from 'react';
import ChangePassword from './ChangePassword';

const API = '/api';
const inp = {width:'100%',padding:'8px 12px',border:'1px solid #e2e8f0',borderRadius:'6px',fontSize:'14px',boxSizing:'border-box',marginBottom:'10px'};
const btn = (s={}) => ({padding:'8px 16px',borderRadius:'6px',border:'none',cursor:'pointer',fontWeight:'500',fontSize:'14px',...s});
const sc = (s) => ({case_created:'#d69e2e',director_approved:'#3182ce',doc_under_review:'#d69e2e',m1_reviewed:'#553c9a',m2_reviewed:'#553c9a',d1_doc_approved:'#276749',both_dirs_approved:'#1a365d',payment_scheduled:'#276749',paid:'#38a169'}[s]||'#718096');

export default function AdminDashboard({ user, onLogout }) {
  const [tab, setTab] = useState('users');
  const [offices, setOffices] = useState([]);
  const [users, setUsers] = useState([]);
  const [cases, setCases] = useState([]);
  const [staff, setStaff] = useState([]);
  const [msg, setMsg] = useState('');
  const [msgType, setMsgType] = useState('success');
  const [caseFilter, setCaseFilter] = useState('');
  const [caseTab, setCaseTab] = useState('pending');

  // Add office state
  const [showAddOffice, setShowAddOffice] = useState(false);
  const [newOffice, setNewOffice] = useState({office_code:'',office_name:'',address:'',city:'',state:''});

  // Add user state
  const [showAddUser, setShowAddUser] = useState(false);
  const [newUser, setNewUser] = useState({name:'',mobile:'',password:'',role:'employee',office_ids:[],manager1_id:'',manager2_id:'',can_create_cases:1});

  // Edit user state
  const [editingUser, setEditingUser] = useState(null);
  const [resetPwdUser, setResetPwdUser] = useState(null);
  const [newPassword, setNewPassword] = useState('');
  const [showChangePw, setShowChangePw] = useState(false);

  const getHeaders = () => ({'Content-Type':'application/json','Authorization':`Bearer ${localStorage.getItem('token')}`});
  const headers = getHeaders();

  const showMsg = (m, t='success') => { setMsg(m); setMsgType(t); setTimeout(()=>setMsg(''),4000); };

  const fetchAll = async () => {
    const [ro, ru, rc, rs] = await Promise.all([
      fetch(`${API}/users/offices`,{headers:getHeaders()}).then(r=>r.json()),
      fetch(`${API}/users`,{headers:getHeaders()}).then(r=>r.json()),
      fetch(`${API}/cases`,{headers:getHeaders()}).then(r=>r.json()),
      fetch(`${API}/users/staff`,{headers:getHeaders()}).then(r=>r.json()),
    ]);
    setOffices(ro.offices||[]);
    setUsers(ru.users||[]);
    setCases(rc.cases||[]);
    setStaff(rs.users||[]);
  };

  useEffect(()=>{ fetchAll(); },[]);

  const addOffice = async () => {
    const r = await fetch(`${API}/users/offices`,{method:'POST',headers:getHeaders(),body:JSON.stringify(newOffice)});
    const d = await r.json();
    if(d.office){showMsg('Office added!');fetchAll();setShowAddOffice(false);setNewOffice({office_code:'',office_name:'',address:'',city:'',state:''});}
    else showMsg(d.message||'Error','error');
  };

  const addUser = async () => {
    if(!newUser.name||!newUser.mobile||!newUser.password) return showMsg('Name, mobile and password required','error');
    if(newUser.role==='employee' && newUser.office_ids.length===0) return showMsg('At least one office is required for Employee','error');
    if(newUser.role==='employee' && !newUser.manager1_id) return showMsg('Manager1 is required for Employee','error');
    if(newUser.role==='manager1' && newUser.office_ids.length===0) return showMsg('At least one office is required for Manager1','error');
    const r = await fetch(`${API}/users`,{method:'POST',headers:getHeaders(),body:JSON.stringify(newUser)});
    const d = await r.json();
    if(d.user){showMsg('User added!');fetchAll();setShowAddUser(false);setNewUser({name:'',mobile:'',password:'',role:'employee',office_ids:[],manager1_id:'',manager2_id:'',can_create_cases:1});setTimeout(()=>fetchAll(),500);}
    else showMsg(d.message||'Error','error');
  };

  const updateUser = async () => {
    const r = await fetch(`${API}/users/${editingUser.id}`,{method:'PUT',headers:getHeaders(),body:JSON.stringify(editingUser)});
    const d = await r.json();
    if(d.success){showMsg('User updated!');fetchAll();setEditingUser(null);}
    else showMsg(d.message||'Error','error');
  };

  const openEditUser = async (u) => {
    setEditingUser({...u, office_ids: u.office_id ? [u.office_id] : []});
    try {
      const r = await fetch(`${API}/users/${u.id}/offices`,{headers:getHeaders()});
      const d = await r.json();
      if (d.office_ids) setEditingUser(prev => prev ? {...prev, office_ids: d.office_ids} : prev);
    } catch {}
  };

  const resetPassword = async () => {
    if(!newPassword) return showMsg('Enter new password','error');
    const r = await fetch(`${API}/users/${resetPwdUser.id}/reset-password`,{method:'PUT',headers:getHeaders(),body:JSON.stringify({password:newPassword})});
    const d = await r.json();
    if(d.success){showMsg('Password reset!');setResetPwdUser(null);setNewPassword('');}
    else showMsg(d.message||'Error','error');
  };

  const toggleUser = async (id) => {
    await fetch(`${API}/users/${id}/toggle`,{method:'PUT',headers:getHeaders()});
    fetchAll();
  };

  const deleteCase = async (c) => {
    if(!window.confirm(`DELETE case ${c.case_number}?\n\nThis will permanently delete all documents, approvals and payment data. This cannot be undone!`)) return;
    const r = await fetch(`${API}/cases/${c.id}`,{method:'DELETE',headers:getHeaders()});
    const d = await r.json();
    if(d.success){showMsg(d.message);}
    else showMsg(d.message||'Error','error');
    fetchAll();
  };

  const employees = staff.filter(u=>u.role==='employee');
  const manager1s = staff.filter(u=>u.role==='manager1');
  const manager2s = users.filter(u=>u.role==='manager2');

  const filteredCases = cases.filter(c => {
    const matchTab = caseTab==='paid' ? c.status==='paid' : c.status!=='paid';
    const matchFilter = !caseFilter || c.case_number?.toLowerCase().includes(caseFilter.toLowerCase()) ||
      c.subscriber_name?.toLowerCase().includes(caseFilter.toLowerCase());
    return matchTab && matchFilter;
  });

  const tabs = ['users','offices','cases'];

  return (
    <div style={{minHeight:'100vh',background:'#f7fafc',fontFamily:"'Segoe UI',sans-serif"}}>
      {/* Header */}
      <div style={{background:'#1a365d',color:'white',padding:'0 24px',display:'flex',alignItems:'center',justifyContent:'space-between',height:'60px'}}>
        <div style={{display:'flex',alignItems:'center',gap:'12px'}}>
          <span style={{fontSize:'20px'}}>🏦</span>
          <div>
            <div style={{fontWeight:'700',fontSize:'16px'}}>AH Chits — Admin Panel</div>
            <div style={{fontSize:'11px',opacity:0.7}}>Full System Access</div>
          </div>
        </div>
        <div style={{display:'flex',alignItems:'center',gap:'12px'}}>
          <span style={{fontSize:'13px',opacity:0.8}}>{user.name}</span>
          <button onClick={()=>setShowChangePw(true)} style={btn({background:'rgba(255,255,255,0.2)',color:'white',padding:'6px 14px',fontSize:'13px'})}>🔒 Change Password</button>
          <button onClick={onLogout} style={btn({background:'#e53e3e',color:'white',padding:'6px 14px',fontSize:'13px'})}>Logout</button>
        </div>
      </div>

            {/* Summary Cards */}
      <div style={{display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:'16px',padding:'20px 24px 0'}}>
        {[
          {label:'Total Cases',value:cases.length,color:'#2b6cb0',icon:'📋'},
          {label:'Pending',value:cases.filter(c=>c.status!=='paid').length,color:'#d69e2e',icon:'⏳'},
          {label:'Paid',value:cases.filter(c=>c.status==='paid').length,color:'#38a169',icon:'✅'},
          {label:'Total Users',value:users.length,color:'#553c9a',icon:'👥'},
        ].map(card=>(
          <div key={card.label} style={{background:'white',borderRadius:'8px',padding:'16px 20px',boxShadow:'0 1px 3px rgba(0,0,0,0.06)',borderTop:`3px solid ${card.color}`}}>
            <div style={{fontSize:'24px',fontWeight:'700',color:card.color}}>{card.icon} {card.value}</div>
            <div style={{fontSize:'13px',color:'#718096',marginTop:'2px'}}>{card.label}</div>
          </div>
        ))}
      </div>

      {/* Tabs */}
      <div style={{background:'white',borderBottom:'1px solid #e2e8f0',padding:'0 24px',display:'flex',gap:'4px',marginTop:'16px'}}>
        {tabs.map(t=>(
          <button key={t} onClick={()=>setTab(t)} style={btn({background:'none',color:tab===t?'#2b6cb0':'#718096',borderBottom:tab===t?'2px solid #2b6cb0':'2px solid transparent',borderRadius:0,padding:'14px 16px',textTransform:'capitalize',fontSize:'14px'})}>
            {t==='users'?`Users (${users.length})`:t==='offices'?`Offices (${offices.length})`:`Cases (${cases.length})`}
          </button>
        ))}
      </div>

      {/* Message */}
      <div style={{padding:'0 24px'}}>
        {msg && <div style={{background:msgType==='error'?'#fff5f5':'#f0fff4',color:msgType==='error'?'#c53030':'#276749',padding:'10px 16px',borderRadius:'8px',marginTop:'16px',border:`1px solid ${msgType==='error'?'#feb2b2':'#9ae6b4'}`}}>
          {msg} <button onClick={()=>setMsg('')} style={{float:'right',background:'none',border:'none',cursor:'pointer'}}>✕</button>
        </div>}
      </div>

      <div style={{padding:'20px 24px',maxWidth:'1200px',margin:'0 auto'}}>

        {/* ── USERS TAB ── */}
        {tab==='users' && (
          <div>
            <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:'16px'}}>
              <h2 style={{margin:0,color:'#1a365d'}}>User Management</h2>
              <button onClick={()=>setShowAddUser(!showAddUser)} style={btn({background:'#2b6cb0',color:'white'})}>+ Add User</button>
            </div>

            {/* Add User Form */}
            {showAddUser && (
              <div style={{background:'white',padding:'20px',borderRadius:'8px',boxShadow:'0 2px 8px rgba(0,0,0,0.1)',marginBottom:'16px'}}>
                <h3 style={{margin:'0 0 16px',color:'#1a365d'}}>New User</h3>
                <div style={{display:'grid',gridTemplateColumns:'1fr 1fr 1fr',gap:'0 12px'}}>
                  <div><label style={{fontSize:'12px',color:'#718096'}}>Full Name *</label><input style={inp} value={newUser.name} onChange={e=>setNewUser({...newUser,name:e.target.value})} placeholder="Full Name"/></div>
                  <div><label style={{fontSize:'12px',color:'#718096'}}>Mobile *</label><input style={inp} value={newUser.mobile} onChange={e=>setNewUser({...newUser,mobile:e.target.value})} placeholder="10 digit mobile"/></div>
                  <div><label style={{fontSize:'12px',color:'#718096'}}>Email</label><input style={inp} type="email" autoComplete="off" value={newUser.email||''} onChange={e=>setNewUser({...newUser,email:e.target.value})} placeholder="name@example.com"/></div>
                  <div><label style={{fontSize:'12px',color:'#718096'}}>Password *</label><input style={inp} type="password" value={newUser.password} onChange={e=>setNewUser({...newUser,password:e.target.value})} placeholder="Password"/></div>
                  <div><label style={{fontSize:'12px',color:'#718096'}}>Role *</label>
                    <select style={inp} value={newUser.role} onChange={e=>setNewUser({...newUser,role:e.target.value})}>
                      {['employee','manager1','manager2','director1','director2','accounts','admin'].map(r=><option key={r} value={r}>{r}</option>)}
                    </select>
                  </div>
                  <div style={{gridColumn:'span 2'}}><label style={{fontSize:'12px',color:'#718096'}}>Offices (select one or more)</label>
                    <div style={{display:'flex',flexWrap:'wrap',gap:'10px',border:'1px solid #e2e8f0',borderRadius:'6px',padding:'10px',marginBottom:'10px'}}>
                      {offices.map(o=>(
                        <label key={o.id} style={{display:'flex',alignItems:'center',gap:'5px',fontSize:'13px',cursor:'pointer'}}>
                          <input type="checkbox" checked={newUser.office_ids.includes(o.id)}
                            onChange={e=>{
                              const ids = e.target.checked ? [...newUser.office_ids, o.id] : newUser.office_ids.filter(id=>id!==o.id);
                              setNewUser({...newUser, office_ids: ids});
                            }} />
                          {o.office_name}
                        </label>
                      ))}
                    </div>
                  </div>
                  {newUser.role==='manager2'&&<div><label style={{fontSize:'12px',color:'#718096'}}>Can Create Cases</label>
                    <select style={inp} value={newUser.can_create_cases} onChange={e=>setNewUser({...newUser,can_create_cases:parseInt(e.target.value)})}>
                      <option value={1}>Yes — Creator</option>
                      <option value={0}>No — View Only</option>
                    </select>
                  </div>}
                  {newUser.role==='employee'&&<div><label style={{fontSize:'12px',color:'#718096'}}>Reports to Manager1</label>
                    <select style={inp} value={newUser.manager1_id} onChange={e=>setNewUser({...newUser,manager1_id:e.target.value})}>
                      <option value="">Select Manager1</option>
                      {manager1s.map(m=><option key={m.id} value={m.id}>{m.name}</option>)}
                    </select>
                  </div>}
                  {newUser.role==='manager1'&&<div><label style={{fontSize:'12px',color:'#718096'}}>Reports to Manager2</label>
                    <select style={inp} value={newUser.manager2_id} onChange={e=>setNewUser({...newUser,manager2_id:e.target.value})}>
                      <option value="">Select Manager2</option>
                      {manager2s.map(m=><option key={m.id} value={m.id}>{m.name}</option>)}
                    </select>
                  </div>}
                </div>
                <div style={{display:'flex',gap:'8px'}}>
                  <button onClick={addUser} style={btn({background:'#38a169',color:'white'})}>Save User</button>
                  <button onClick={()=>setShowAddUser(false)} style={btn({background:'#e2e8f0',color:'#4a5568'})}>Cancel</button>
                </div>
              </div>
            )}

            {/* Edit User Modal */}
            {editingUser && (
              <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.5)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:1000,padding:'16px'}}>
                <div style={{background:'white',borderRadius:'10px',padding:'24px',width:'100%',maxWidth:'520px',maxHeight:'90vh',overflowY:'auto'}}>
                  <div style={{display:'flex',justifyContent:'space-between',marginBottom:'16px'}}>
                    <h3 style={{margin:0,color:'#1a365d'}}>Edit User — {editingUser.name}</h3>
                    <button onClick={()=>setEditingUser(null)} style={{background:'none',border:'none',fontSize:'18px',cursor:'pointer'}}>✕</button>
                  </div>
                  <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'0 12px'}}>
                    <div><label style={{fontSize:'12px',color:'#718096'}}>Full Name</label><input style={inp} value={editingUser.name||''} onChange={e=>setEditingUser({...editingUser,name:e.target.value})}/></div>
                    <div><label style={{fontSize:'12px',color:'#718096'}}>Mobile</label><input style={inp} value={editingUser.mobile||''} onChange={e=>setEditingUser({...editingUser,mobile:e.target.value})}/></div>
                    <div><label style={{fontSize:'12px',color:'#718096'}}>Email</label><input style={inp} type="email" autoComplete="off" value={editingUser.email||''} onChange={e=>setEditingUser({...editingUser,email:e.target.value})} placeholder="name@example.com"/></div>
                    <div><label style={{fontSize:'12px',color:'#718096'}}>Role</label>
                      <select style={inp} value={editingUser.role||''} onChange={e=>setEditingUser({...editingUser,role:e.target.value})}>
                        {['employee','manager1','manager2','director1','director2','accounts','admin'].map(r=><option key={r} value={r}>{r}</option>)}
                      </select>
                    </div>
                    <div style={{gridColumn:'1/-1'}}><label style={{fontSize:'12px',color:'#718096'}}>Offices (select one or more)</label>
                      <div style={{display:'flex',flexWrap:'wrap',gap:'10px',border:'1px solid #e2e8f0',borderRadius:'6px',padding:'10px',marginBottom:'10px'}}>
                        {offices.map(o=>(
                          <label key={o.id} style={{display:'flex',alignItems:'center',gap:'5px',fontSize:'13px',cursor:'pointer'}}>
                            <input type="checkbox" checked={(editingUser.office_ids||[]).includes(o.id)}
                              onChange={e=>{
                                const current = editingUser.office_ids||[];
                                const ids = e.target.checked ? [...current, o.id] : current.filter(id=>id!==o.id);
                                setEditingUser({...editingUser, office_ids: ids});
                              }} />
                            {o.office_name}
                          </label>
                        ))}
                      </div>
                    </div>
                    {editingUser.role==='employee'&&<div style={{gridColumn:'1/-1'}}><label style={{fontSize:'12px',color:'#718096'}}>Reports to Manager1</label>
                      <select style={inp} value={editingUser.manager1_id||''} onChange={e=>setEditingUser({...editingUser,manager1_id:e.target.value})}>
                        <option value="">Select Manager1</option>
                        {manager1s.map(m=><option key={m.id} value={m.id}>{m.name}</option>)}
                      </select>
                    </div>}
                    {editingUser.role==='manager1'&&<div style={{gridColumn:'1/-1'}}><label style={{fontSize:'12px',color:'#718096'}}>Reports to Manager2</label>
                      <select style={inp} value={editingUser.manager2_id||''} onChange={e=>setEditingUser({...editingUser,manager2_id:e.target.value})}>
                        <option value="">Select Manager2</option>
                        {manager2s.map(m=><option key={m.id} value={m.id}>{m.name}</option>)}
                      </select>
                    </div>}
                    {editingUser.role==='manager2'&&<div style={{gridColumn:'1/-1'}}><label style={{fontSize:'12px',color:'#718096'}}>Can Create Cases</label>
                      <select style={inp} value={(editingUser.can_create_cases===undefined||editingUser.can_create_cases===null)?1:editingUser.can_create_cases} onChange={e=>setEditingUser({...editingUser,can_create_cases:parseInt(e.target.value)})}>
                        <option value={1}>Yes — Creator</option>
                        <option value={0}>No — View Only</option>
                      </select>
                    </div>}
                    <div><label style={{fontSize:'12px',color:'#718096'}}>Status</label>
                      <select style={inp} value={editingUser.is_active||1} onChange={e=>setEditingUser({...editingUser,is_active:parseInt(e.target.value)})}>
                        <option value={1}>Active</option>
                        <option value={0}>Inactive</option>
                      </select>
                    </div>
                  </div>
                  <div style={{display:'flex',gap:'8px',marginTop:'8px'}}>
                    <button onClick={updateUser} style={btn({background:'#38a169',color:'white'})}>Save Changes</button>
                    <button onClick={()=>setEditingUser(null)} style={btn({background:'#e2e8f0',color:'#4a5568'})}>Cancel</button>
                  </div>
                </div>
              </div>
            )}

            {/* Reset Password Modal */}
            {resetPwdUser && (
              <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.5)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:1000}}>
                <div style={{background:'white',borderRadius:'10px',padding:'24px',width:'100%',maxWidth:'380px'}}>
                  <h3 style={{margin:'0 0 16px',color:'#1a365d'}}>Reset Password — {resetPwdUser.name}</h3>
                  <input style={inp} type="password" placeholder="New Password" value={newPassword} onChange={e=>setNewPassword(e.target.value)}/>
                  <div style={{display:'flex',gap:'8px'}}>
                    <button onClick={resetPassword} style={btn({background:'#e53e3e',color:'white'})}>Reset Password</button>
                    <button onClick={()=>{setResetPwdUser(null);setNewPassword('');}} style={btn({background:'#e2e8f0',color:'#4a5568'})}>Cancel</button>
                  </div>
                </div>
              </div>
            )}

            {/* Users Table */}
            <div style={{background:'white',borderRadius:'8px',boxShadow:'0 1px 3px rgba(0,0,0,0.06)',overflow:'auto'}}>
              <table style={{width:'100%',borderCollapse:'collapse'}}>
                <thead><tr style={{background:'#edf2f7'}}>
                  {['Name','Mobile','Role','Office','Manager','Status','Actions'].map(h=>(
                    <th key={h} style={{padding:'12px 16px',textAlign:'left',fontSize:'12px',color:'#4a5568',fontWeight:'600',textTransform:'uppercase'}}>{h}</th>
                  ))}
                </tr></thead>
                <tbody>
                  {users.map((u,i)=>{
                    const mgr = u.manager1_id ? users.find(x=>x.id===u.manager1_id)?.name : u.manager2_id ? users.find(x=>x.id===u.manager2_id)?.name : '—';
                    return (
                      <tr key={u.id} style={{borderTop:'1px solid #e2e8f0',background:i%2===0?'white':'#f7fafc'}}>
                        <td style={{padding:'12px 16px',fontWeight:'500'}}>{u.name}</td>
                        <td style={{padding:'12px 16px',fontSize:'13px'}}>{u.mobile}</td>
                        <td style={{padding:'12px 16px'}}><span style={{background:'#ebf8ff',color:'#2b6cb0',padding:'2px 8px',borderRadius:'12px',fontSize:'11px',fontWeight:'600'}}>{u.role}</span></td>
                        <td style={{padding:'12px 16px',fontSize:'13px',color:'#718096'}}>{u.office_name||'—'}</td>
                        <td style={{padding:'12px 16px',fontSize:'12px',color:'#718096'}}>{mgr}</td>
                        <td style={{padding:'12px 16px'}}>
                          <span style={{background:u.is_active?'#f0fff4':'#fff5f5',color:u.is_active?'#276749':'#c53030',padding:'2px 8px',borderRadius:'12px',fontSize:'11px',fontWeight:'600'}}>{u.is_active?'Active':'Inactive'}</span>
                        </td>
                        <td style={{padding:'12px 16px'}}>
                          <div style={{display:'flex',gap:'4px',flexWrap:'wrap'}}>
                            <button onClick={()=>openEditUser(u)} style={btn({background:'#ebf8ff',color:'#2b6cb0',padding:'4px 10px',fontSize:'11px'})}>Edit</button>
                            <button onClick={()=>setResetPwdUser(u)} style={btn({background:'#fef3c7',color:'#92400e',padding:'4px 10px',fontSize:'11px'})}>Reset Pwd</button>
                            <button onClick={()=>toggleUser(u.id)} style={btn({background:u.is_active?'#fed7d7':'#c6f6d5',color:u.is_active?'#c53030':'#276749',padding:'4px 10px',fontSize:'11px'})}>{u.is_active?'Deactivate':'Activate'}</button>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {/* ── OFFICES TAB ── */}
        {tab==='offices' && (
          <div>
            <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:'16px'}}>
              <h2 style={{margin:0,color:'#1a365d'}}>Offices ({offices.length})</h2>
              <button onClick={()=>setShowAddOffice(!showAddOffice)} style={btn({background:'#2b6cb0',color:'white'})}>+ Add Office</button>
            </div>
            {showAddOffice && (
              <div style={{background:'white',padding:'20px',borderRadius:'8px',boxShadow:'0 2px 8px rgba(0,0,0,0.1)',marginBottom:'16px'}}>
                <h3 style={{margin:'0 0 16px'}}>New Office</h3>
                <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'0 12px'}}>
                  <div><label style={{fontSize:'12px',color:'#718096'}}>Office Code *</label><input style={inp} placeholder="e.g. BLR002" value={newOffice.office_code} onChange={e=>setNewOffice({...newOffice,office_code:e.target.value})}/></div>
                  <div><label style={{fontSize:'12px',color:'#718096'}}>Office Name *</label><input style={inp} placeholder="Office Name" value={newOffice.office_name} onChange={e=>setNewOffice({...newOffice,office_name:e.target.value})}/></div>
                  <div><label style={{fontSize:'12px',color:'#718096'}}>City</label><input style={inp} placeholder="City" value={newOffice.city} onChange={e=>setNewOffice({...newOffice,city:e.target.value})}/></div>
                  <div><label style={{fontSize:'12px',color:'#718096'}}>State</label><input style={inp} placeholder="State" value={newOffice.state} onChange={e=>setNewOffice({...newOffice,state:e.target.value})}/></div>
                  <div style={{gridColumn:'1/-1'}}><label style={{fontSize:'12px',color:'#718096'}}>Address</label><input style={inp} placeholder="Full Address" value={newOffice.address} onChange={e=>setNewOffice({...newOffice,address:e.target.value})}/></div>
                </div>
                <div style={{display:'flex',gap:'8px'}}>
                  <button onClick={addOffice} style={btn({background:'#38a169',color:'white'})}>Save Office</button>
                  <button onClick={()=>setShowAddOffice(false)} style={btn({background:'#e2e8f0',color:'#4a5568'})}>Cancel</button>
                </div>
              </div>
            )}
            <div style={{background:'white',borderRadius:'8px',boxShadow:'0 1px 3px rgba(0,0,0,0.06)',overflow:'hidden'}}>
              <table style={{width:'100%',borderCollapse:'collapse'}}>
                <thead><tr style={{background:'#edf2f7'}}>
                  {['Code','Name','City','Address','Staff'].map(h=>(
                    <th key={h} style={{padding:'12px 16px',textAlign:'left',fontSize:'12px',color:'#4a5568',fontWeight:'600',textTransform:'uppercase'}}>{h}</th>
                  ))}
                </tr></thead>
                <tbody>
                  {offices.map((o,i)=>(
                    <tr key={o.id} style={{borderTop:'1px solid #e2e8f0',background:i%2===0?'white':'#f7fafc'}}>
                      <td style={{padding:'12px 16px',fontWeight:'600',color:'#2b6cb0'}}>{o.office_code}</td>
                      <td style={{padding:'12px 16px',fontWeight:'500'}}>{o.office_name}</td>
                      <td style={{padding:'12px 16px',color:'#718096'}}>{o.city}</td>
                      <td style={{padding:'12px 16px',color:'#718096',fontSize:'13px'}}>{o.address||'—'}</td>
                      <td style={{padding:'12px 16px',fontSize:'13px',color:'#718096'}}>{users.filter(u=>u.office_name===o.office_name).length} users</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {/* ── CASES TAB ── */}
        {tab==='cases' && (
          <div>
            <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:'16px',flexWrap:'wrap',gap:'10px'}}>
              <div style={{display:'flex',alignItems:'center',gap:'8px'}}>
                <h2 style={{margin:0,color:'#1a365d'}}>All Cases</h2>
                <div style={{display:'flex',gap:'4px',background:'white',padding:'4px',borderRadius:'8px',boxShadow:'0 1px 3px rgba(0,0,0,0.06)'}}>
                  <button onClick={()=>setCaseTab('pending')} style={btn({background:caseTab==='pending'?'#1d4ed8':'transparent',color:caseTab==='pending'?'white':'#6b7280',padding:'5px 14px',fontSize:'12px'})}>Pending ({cases.filter(c=>c.status!=='paid').length})</button>
                  <button onClick={()=>setCaseTab('paid')} style={btn({background:caseTab==='paid'?'#16a34a':'transparent',color:caseTab==='paid'?'white':'#6b7280',padding:'5px 14px',fontSize:'12px'})}>Paid ({cases.filter(c=>c.status==='paid').length})</button>
                </div>
              </div>
              <input placeholder="Search case no or subscriber..." value={caseFilter} onChange={e=>setCaseFilter(e.target.value)}
                style={{padding:'7px 12px',border:'1px solid #e2e8f0',borderRadius:'6px',fontSize:'13px',width:'260px'}}/>
            </div>
            <div style={{background:'white',borderRadius:'8px',boxShadow:'0 1px 3px rgba(0,0,0,0.06)',overflow:'auto'}}>
              <table style={{width:'100%',borderCollapse:'collapse'}}>
                <thead><tr style={{background:'#edf2f7'}}>
                  {['Case No','Subscriber','Chit Value','Prize Amt','Office','Status','Created By','Action'].map(h=>(
                    <th key={h} style={{padding:'12px 16px',textAlign:'left',fontSize:'12px',color:'#4a5568',fontWeight:'600',textTransform:'uppercase'}}>{h}</th>
                  ))}
                </tr></thead>
                <tbody>
                  {filteredCases.map((c,i)=>(
                    <tr key={c.id} style={{borderTop:'1px solid #e2e8f0',background:i%2===0?'white':'#f7fafc'}}>
                      <td style={{padding:'12px 16px',fontWeight:'600',color:'#2b6cb0'}}>{c.case_number}</td>
                      <td style={{padding:'12px 16px',fontWeight:'500'}}>{c.subscriber_name||'—'}</td>
                      <td style={{padding:'12px 16px',fontSize:'13px'}}>₹{Number(c.chit_value||0).toLocaleString('en-IN', {timeZone:'Asia/Kolkata'})}</td>
                      <td style={{padding:'12px 16px',fontWeight:'600',color:'#276749'}}>₹{Number(c.prize_amount||0).toLocaleString('en-IN', {timeZone:'Asia/Kolkata'})}</td>
                      <td style={{padding:'12px 16px',fontSize:'13px',color:'#718096'}}>{c.office_name||'—'}</td>
                      <td style={{padding:'12px 16px'}}>
                        <span style={{background:sc(c.status)+'20',color:sc(c.status),padding:'2px 8px',borderRadius:'12px',fontSize:'11px',fontWeight:'600'}}>{c.status}</span>
                      </td>
                      <td style={{padding:'12px 16px',fontSize:'13px',color:'#718096'}}>{c.created_by_name||'—'}</td>
                      <td style={{padding:'12px 16px'}}>
                        <button onClick={()=>deleteCase(c)} style={btn({background:'#fed7d7',color:'#c53030',padding:'4px 12px',fontSize:'12px'})}>🗑 Delete</button>
                      </td>
                    </tr>
                  ))}
                  {filteredCases.length===0&&<tr><td colSpan="8" style={{padding:'32px',textAlign:'center',color:'#a0aec0'}}>No cases found</td></tr>}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
      {showChangePw && (
        <ChangePassword token={localStorage.getItem('token')} onClose={() => setShowChangePw(false)} />
      )}
    </div>
  );
}
